import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs/operators';
import { BreadcrumbItem } from './breadcrumb-item';

@Component({
    selector: 'app-breadcrumb',
    templateUrl: './breadcrumb.component.html',
})
export class BreadcrumbComponent implements OnInit {
    static readonly ROUTE_DATA_BREADCRUMB = 'breadcrumb';
    static readonly ROUTE_DATA_CUSTOM_BREADCRUMB = 'customBreadcrumb';
    breadcrumbItems: BreadcrumbItem[] = [];

    constructor(
        private router: Router,
        private activatedRoute: ActivatedRoute,
        private translateService: TranslateService,
        private toastr: ToastrService
    ) {}

    ngOnInit(): void {
        this.updateBreadcrumbs();

        this.router.events
            .pipe(filter(event => event instanceof NavigationEnd))
            .subscribe(() => {
                this.updateBreadcrumbs();
            });
    }

    private updateBreadcrumbs(): void {
        this.breadcrumbItems = this.createBreadcrumbs(this.activatedRoute.root);
    }

    private createBreadcrumbs(
        route: ActivatedRoute,
        url: string = '',
        breadcrumbs: BreadcrumbItem[] = []
    ): BreadcrumbItem[] {
        const children: ActivatedRoute[] = route.children;

        for (const child of children) {
            const routeURL: string = child.snapshot.url.map(segment => segment.path).join('/');
            if (routeURL !== '') {
                url += `/${routeURL}`;
            }

            const label = child.snapshot.data[BreadcrumbComponent.ROUTE_DATA_BREADCRUMB];
            const customField = child.snapshot.data[BreadcrumbComponent.ROUTE_DATA_CUSTOM_BREADCRUMB];
            const id = child.snapshot.params.id;
            const queryParams = child.snapshot.queryParams;

            if (customField) {
                const dynamicLabel = child.snapshot.params[customField];
                if (dynamicLabel) {
                    breadcrumbs.push({ label, url, id, dynamicLabel, queryParams });
                }
            } else if (label) {
                breadcrumbs.push({ label, url, id, queryParams });
            }

            return this.createBreadcrumbs(child, url, breadcrumbs);
        }

        return breadcrumbs;
    }

    copyIdPayment(): void {
        this.toastr.success(this.translateService.instant('messages.success.copyIdPayment'));
    }

    goBack(): void {
        if (this.breadcrumbItems.length < 2) {
            return;
        }

        const previousBreadcrumb = this.breadcrumbItems[this.breadcrumbItems.length - 2];
        const queryParams = previousBreadcrumb.queryParams
            ? new URLSearchParams(previousBreadcrumb.queryParams).toString()
            : '';
        const url = queryParams ? `${previousBreadcrumb.url}?${queryParams}` : previousBreadcrumb.url;

        this.router.navigateByUrl(url);
    }
}
